import * as Inovx from '@shared';
import RoleConstants from '../constants/RoleConstants';
import RoleServices from '../services/RoleServices';
import RoleStore from '../stores/RoleStore';

var SystemActions = Inovx.Shared.System.Actions;
var SystemStore = Inovx.Shared.System.Store;
var FormHelper = Inovx.Shared.Common.FormHelper;

declare var InovxLoader: any;

function _finishEdit() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: RoleConstants.ROLE_FINISH_EDIT
    });
}

function _receiveAllRoles(data: IOrganizationRole[]): void {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: RoleConstants.ROLE_GET_ALL,
        data: data
    });
}

function receiveSettingsData(data: IRoleSettings) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: RoleConstants.ROLE_RECIEVE_SETTINGS_DATA,
        data: data
    });
}

function receiveHint(data: IExternalGroup[], callback: any) {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: RoleConstants.ROLE_RECEIVE_SEARCH_HINT,
        data: data,
        callback: callback
    });
}

function sendInvalidSave() {
    Inovx.Shared.Flux.AppDispatcher.dispatch({
        actionType: RoleConstants.ROLE_INVALID_ADD
    });
}

var RoleActions = {
    getAllRoles(callback?: any, errorCallback?: IErrorCallback, ignoreDefaultError?: boolean): void {
        RoleServices.getAll(function (data) {
            if (callback !== undefined && callback != null) {
                callback();
            }
            _receiveAllRoles(data);
        }, function (error) {
            if (errorCallback) {
                errorCallback(error);
            }
        }, ignoreDefaultError);
    },

    getSettings(callback?: (data: IRoleSettings) => void, errorCallback?: IErrorCallback) {
        RoleServices.getSettings((settings) => {
            callback?.(settings);
            receiveSettingsData(settings);
        }, (error) => {
            errorCallback?.(error);
        }, true);
    },

    beginAdd(isLinkedRole: boolean): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_BEGIN_ADD,
            isLinkedRole: isLinkedRole
        });
    },

    createRole(callback?: any): void {
        if (RoleStore.getIsValidObject(RoleConstants.ROLE_ADD_FORM)) {
            if (!SystemStore.isActionInProgress(RoleConstants.ROLE_ADD)) {
                SystemActions.beginAction(RoleConstants.ROLE_ADD);

                var role = RoleStore.getRole();
                var externalGroups = role.LinkedExternalGroups;
                var externalGroupIDs: string[] = [];
                for (var index in externalGroups) {
                    var group = externalGroups[index];
                    externalGroupIDs.push(group.ID);
                }

                RoleServices.createRole(FormHelper.trim(role), externalGroupIDs,
                    function () {
                        RoleActions.refreshData();
                        if (callback !== undefined && callback != null) {
                            callback();
                        }

                        _finishEdit();
                        SystemActions.endAction(RoleConstants.ROLE_ADD);
                    },
                    function (error) {
                        SystemActions.endAction(RoleConstants.ROLE_ADD);
                    });
            }
        } else {
            sendInvalidSave();
        }
    },

    beginEdit(role: IOrganizationRole): void {
        RoleServices.getRoleDetail(role.ID,
            function (role) {
                Inovx.Shared.Flux.AppDispatcher.dispatch({
                    actionType: RoleConstants.ROLE_BEGIN_EDIT,
                    role: role
                });
            }, function (error) {
            });
    },

    editRole(callback?: any): void {
        if (RoleStore.getIsValidObject(RoleConstants.ROLE_ADD_FORM)) {
            if (!SystemStore.isActionInProgress(RoleConstants.ROLE_EDIT)) {
                SystemActions.beginAction(RoleConstants.ROLE_EDIT);

                var role = RoleStore.getRole();
                var externalGroups = role.LinkedExternalGroups;
                var externalGroupIDs: string[] = [];
                for (var index in externalGroups) {
                    var group = externalGroups[index];
                    externalGroupIDs.push(group.ID);
                }

                RoleServices.editRole(FormHelper.trim(role), externalGroupIDs,
                    function (data) {
                        RoleActions.refreshData();
                        if (callback !== undefined && callback != null) {
                            callback();
                        }

                        _finishEdit();
                        SystemActions.endAction(RoleConstants.ROLE_EDIT);
                    },
                    function (error) {
                        SystemActions.endAction(RoleConstants.ROLE_EDIT);
                    });
            }
        } else {
            sendInvalidSave();
        }
    },

    finishEdit(): void {
        if (RoleStore.getHasChanges()) {
            var callbackFunct = RoleStore.getIsEditing() ? RoleActions.editRole : RoleActions.createRole;
            SystemActions.displaySaveChangesDialog({
                message: InovxLoader.t("common:msgBox.saveChanges"),
                confirmCallback: callbackFunct,
                cancelCallback: _finishEdit
            });
        } else {
            _finishEdit();
        }
    },

    deleteRole(role: IOrganizationRole, callback: any): void {
        if (!SystemStore.isActionInProgress(RoleConstants.ROLE_DELETE)) {
            SystemActions.beginAction(RoleConstants.ROLE_DELETE);

            RoleServices.deleteRole(role,
                function () {
                    RoleActions.refreshData();
                    if (callback !== undefined && callback != null) {
                        callback();
                    }

                    SystemActions.endAction(RoleConstants.ROLE_DELETE);
                },
                function (error) {
                    SystemActions.endAction(RoleConstants.ROLE_DELETE);
                });
        }
    },

    editCurrentRole(comp: string, key: string, value: any): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_UPDATE_EDIT,
            component: comp,
            key: key,
            value: value
        });
    },

    addUsers(users: IUser[]): void {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_ADD_USER,
            users: users
        });
    },
    deleteAuthorizedUser(user: IUser) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_DELETE_USER,
            user: user
        });
    },
    refreshData(): void {
        this.getAllRoles();
    },
    addExternalGroup(externalGroup: IExternalGroup) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_ADD_EXTERNAL_GROUP,
            externalGroup: externalGroup
        });
    },
    deleteExternalGroup(externalGroup: IExternalGroup) {
        Inovx.Shared.Flux.AppDispatcher.dispatch({
            actionType: RoleConstants.ROLE_DELETE_EXTERNAL_GROUP,
            externalGroup: externalGroup
        });
    },
    getSearchGroup(hint: string, callback: any) {
        if (!SystemStore.isActionInProgress(RoleConstants.ROLE_DIRECTORY_GROUP_SEARCH)) {
            SystemActions.beginAction(RoleConstants.ROLE_DIRECTORY_GROUP_SEARCH);

            RoleServices.searchGroup(hint,
                function (data) {
                    receiveHint(data, callback);
                    SystemActions.endAction(RoleConstants.ROLE_DIRECTORY_GROUP_SEARCH);
                },
                function (error) {
                    SystemActions.endAction(RoleConstants.ROLE_DIRECTORY_GROUP_SEARCH);
                });
        }
    },
}

export default RoleActions;
